import React from 'react';
import { graphql } from 'gatsby';

import ArchivePage from '../components/archive-page';

export const query = graphql`
query($fieldValue: String!) {
  queryResponse: allPostsPage(
    filter: { category: { name: { eq: $fieldValue } }, 
    language: { eq: "en-US" } }
  ) {
    posts: nodes {
      title
      excerpt
      category {
        name
        path
      }
      tags {
        name
        path
      }
      path
      created(formatString: "MMMM DD, YYYY")
      updated(fromNow: true)
    }
  }
}
`;

const CategoryPageTemplate = ({
  data: {
    queryResponse: { posts },
  },
  pageContext: { fieldValue },
}) => {
  return <ArchivePage posts={posts} title={fieldValue} />;
};

export default CategoryPageTemplate;
